import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"

import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import * as constants from "../constants"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import BodyCarCovarage from "./BodyCarCovarage"
import BodyCarUsefor from "./BodyCarUsefor"
import BodyCarDiscntLife from "./BodyCarDiscntLife"
import BodyCarDiscbody from "./BodyCarDiscbody"
import BodyCarThirdparty from "./BodyCarThirdparty"
import BodyCarExceptions from "./BodyCarExceptions"
import BodyCarExtracar from "./BodyCarExtracar"
import BodyCarAccBank from "./BodyCarAccBank"
import BodyCarAnother from "./BodyCarAnother"
import BodyCarPriority from "./BodyCarPriority"
import BodyCarDiscSlideOld from "./BodyCarDiscSlideOld"
import BodyCarExtraSlideOld from "./BodyCarExtraSlideOld"
import BodyCarSlidePrice from "./BodyCarSlidePrice"
import BodyCarSlideDisc from "./BodyCarSlideDisc"
import AddIcon from "@material-ui/icons/Add"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

const optionStep = [
      { value: "0", label: "حق بیمه پایه" },
      { value: "1", label: "سرمایه" },
      { value: "2", label: "مبلغ ثابت" },
]

class ChangePriceBodyCar extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  bodycar_price_id: "",
                  selectedCompany: "",
                  selectedCarmode: "",
                  selectedCargroup: "",
                  bodycar_price_import_year: "",
                  bodycar_price_import_percent: "",
                  bodycar_price_new_percent: "",
                  bodycar_price_min_disc: "",
                  bodycar_price_max_disc: "",
                  bodycar_price_fixed_amount: "",
                  bodycar_price_fixed_transportation: "",
                  bodycar_price_min_price: "",
                  bodycar_price_max_price: "",
                  bodycar_price_chash: "",
                  bodycar_price_non_fabric: "",
                  bodycar_price_deactive: "0",
                  bodycar_price_together_disc: "0",
                  bodycar_price_no_discount_on_transport: "0",
                  bodycar_price_no_damage_discount_on_transport: "0",
                  bodycar_price_robonbaseprice: "0",
                  bodycar_price_stairs: "0",
                  company_logo_url: "",
                  orderBy: "bodycar_price_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newPriceBodyCar: true,
                  optionCompany: [],
                  optionCarmode: [],
                  optionCargroup: [],
                  openDialog: false,
                  bodycarCovarage: [],
                  bodycarUsefor: [],
                  bodycarDiscntLife: [],
                  bodycarThirdparty: [],
                  bodycarDiscbody: [],
                  bodycarExceptions: [],
                  bodycarExtracar: [],
                  bodycarAccBank: [],
                  bodycarAnother: [],
                  bodycarPriority: [],
                  bodyCarSlideDisc: [],
                  bodyCarExtraSlideOld: [],
                  bodyCarDiscSlideOld: [],
                  bodyCarSlidePrice: [],
                  bodycar_price_covarage_percent: "",
                  selectedUserforCalculate: optionStep[2],
                  selectedCovrageCalculate: optionStep[2],
                  bodycar_price_usefor_percent: "",
                  bodycar_price_discntlife_percent: "",
                  bodycar_price_thirdparty_percent: "",
                  bodycar_price_discbody_percent: "",
                  bodycar_price_accbank_percent: "",
                  bodycar_price_another_percent: "",
                  bodycar_price_priority_percent: "",
                  bodycar_disc_slideold_percent: "",
                  bodycar_extra_slideold_percent: "",
                  bodycar_slideprice_percent: "",
                  bodycar_slidedisc_minpercent: "",
                  bodycar_slidedisc_maxpercent: "",
                  bodycar_slidedisc_instalment_maxpercent: "",
                  bodycar_slidedisc_instalment_minpercent: "",
                  selectedBodycarCovarage: "",
                  selectedBodycarUsefor: "",
                  selectedBodycarDiscntLife: "",
                  selectedBodycarDiscbody: "",
                  selectedBodycarThirdparty: "",
                  selectedBodycarExceptions: "",
                  selectedBodycarExtracar: "",
                  selectedBodycarAccBank: "",
                  selectedBodycarAnother: "",
                  selectedBodycarPriority: "",
                  bodycar_disc_slideold_min: "",
                  bodycar_extra_slideold_min: "",
                  bodycar_slideprice_min: "",
                  bodycar_slidedisc_min: "",
                  bodycar_disc_slideold_max: "",
                  bodycar_extra_slideold_max: "",
                  bodycar_slideprice_max: "",
                  bodycar_slidedisc_max: "",
            }
      }

      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }
      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }
      handleCargroup = (selectedCargroup) => {
            this.setState({ selectedCargroup: selectedCargroup }, () => {})
      }
      handleCarmode = (selectedCarmode) => {
            this.setState({ selectedCarmode: selectedCarmode }, () => {
                  this.filterPriceBodyCar()
                  this.getoptionCargroup()
            })
      }
      handleChangeImportYear = (event) => {
            this.setState({ bodycar_price_import_year: event })
      }
      handleChangeImportPercent = (event) => {
            this.setState({ bodycar_price_import_percent: event })
      }
      handleChangeNewPercent = (event) => {
            this.setState({ bodycar_price_new_percent: event })
      }
      handleChangeMinDisc = (event) => {
            this.setState({ bodycar_price_min_disc: event })
      }
      handleChangeMaxDisc = (event) => {
            this.setState({ bodycar_price_max_disc: event })
      }
      handleChangeFixAmount = (event) => {
            this.setState({ bodycar_price_fixed_amount: event })
      }
      handleChangeFixTransportation = (event) => {
            this.setState({ bodycar_price_fixed_transportation: event })
      }
      handleChangeMinPrice = (event) => {
            this.setState({ bodycar_price_min_price: event })
      }
      handleChangeMaxPrice = (event) => {
            this.setState({ bodycar_price_max_price: event })
      }
      handleChangeCash = (event) => {
            this.setState({ bodycar_price_chash: event })
      }
      handleChangeNonFabric = (event) => {
            this.setState({ bodycar_price_non_fabric: event })
      }
      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany, newPriceBodyCar: true }, () => {
                  this.filterPriceBodyCar()
            })
      }
      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }
      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ bodycar_price_deactive: "0" })
            } else {
                  this.setState({ bodycar_price_deactive: "1" })
            }
      }
      handleChangeTogether_disc = (event) => {
            if (event.target.checked) {
                  this.setState({ bodycar_price_together_disc: "1" })
            } else {
                  this.setState({ bodycar_price_together_disc: "0" })
            }
      }
      handleChangeNoDiscountOnTransport = (event) => {
            if (event.target.checked) {
                  this.setState({ bodycar_price_no_discount_on_transport: "1" })
            } else {
                  this.setState({ bodycar_price_no_discount_on_transport: "0" })
            }
      }
      handleChangeNoDamageDiscountOnTransport = (event) => {
            if (event.target.checked) {
                  this.setState({ bodycar_price_no_damage_discount_on_transport: "1" })
            } else {
                  this.setState({ bodycar_price_no_damage_discount_on_transport: "0" })
            }
      }

      handleChangeRobonBasePrice = (event) => {
            if (event.target.checked) {
                  this.setState({ bodycar_price_robonbaseprice: "1" })
            } else {
                  this.setState({ bodycar_price_robonbaseprice: "0" })
            }
      }

      handleChangeStairs = (event) => {
            if (event.target.checked) {
                  this.setState({ bodycar_price_stairs: "1" })
            } else {
                  this.setState({ bodycar_price_stairs: "0" })
            }
      }

      handleBodycarCovarage = (selectedBodycarCovarage) => {
            this.setState({ selectedBodycarCovarage: selectedBodycarCovarage })
      }

      handleBodycarUsefor = (selectedBodycarUsefor) => {
            this.setState({ selectedBodycarUsefor: selectedBodycarUsefor })
      }

      handleBodycarDiscntLife = (selectedBodycarDiscntLife) => {
            this.setState({ selectedBodycarDiscntLife: selectedBodycarDiscntLife })
      }
      handleBodycarDiscbody = (selectedBodycarDiscbody) => {
            this.setState({ selectedBodycarDiscbody: selectedBodycarDiscbody })
      }
      handleBodycarThirdparty = (selectedBodycarThirdparty) => {
            this.setState({ selectedBodycarThirdparty: selectedBodycarThirdparty })
      }

      handleBodycarExceptions = (selectedBodycarExceptions) => {
            this.setState({ selectedBodycarExceptions: selectedBodycarExceptions })
      }
      handleBodycarExtracar = (selectedBodycarExtracar) => {
            this.setState({ selectedBodycarExtracar: selectedBodycarExtracar })
      }
      handleBodycarAccBank = (selectedBodycarAccBank) => {
            this.setState({ selectedBodycarAccBank: selectedBodycarAccBank })
      }
      handleBodycarAnother = (selectedBodycarAnother) => {
            this.setState({ selectedBodycarAnother: selectedBodycarAnother })
      }
      handleBodycarPriority = (selectedBodycarPriority) => {
            this.setState({ selectedBodycarPriority: selectedBodycarPriority })
      }

      handleSlideDiscPriceMin = (event) => {
            this.setState({ bodycar_slidedisc_min: event })
      }
      handleSlideDiscPriceMax = (event) => {
            this.setState({ bodycar_slidedisc_max: event })
      }

      handleDiscSlideOldMin = (event) => {
            this.setState({ bodycar_disc_slideold_min: event })
      }
      handleDiscSlideOldMax = (event) => {
            this.setState({ bodycar_disc_slideold_max: event })
      }

      handleExtraSlideOldMin = (event) => {
            this.setState({ bodycar_extra_slideold_min: event })
      }
      handleExtraSlideOldMax = (event) => {
            this.setState({ bodycar_extra_slideold_max: event })
      }

      handleSlidePriceMin = (event) => {
            this.setState({ bodycar_slideprice_min: event })
      }
      handleSlidePriceMax = (event) => {
            this.setState({ bodycar_slideprice_max: event })
      }

      handleChangeBodyCarCovaragePrice = (event) => {
            this.setState({ bodycar_price_covarage_percent: event })
      }
      handleChangeBodyCarUseforPrice = (event) => {
            this.setState({ bodycar_price_usefor_percent: event })
      }
      handleChangeBodyCarDiscntLifePrice = (event) => {
            this.setState({ bodycar_price_discntlife_percent: event })
      }
      handleChangeBodyCarDiscbodyPrice = (event) => {
            this.setState({ bodycar_price_discbody_percent: event })
      }
      handleChangeBodyCarThirdpartyPrice = (event) => {
            this.setState({ bodycar_price_thirdparty_percent: event })
      }

      handleChangeBodyCarAccBankPrice = (event) => {
            this.setState({ bodycar_price_accbank_percent: event })
      }
      handleChangeBodyCarAnotherPrice = (event) => {
            this.setState({ bodycar_price_another_percent: event })
      }
      handleChangeBodyCarPriorityPrice = (event) => {
            this.setState({ bodycar_price_priority_percent: event })
      }

      handleChangeDiscSlideOldPercent = (event) => {
            this.setState({ bodycar_disc_slideold_percent: event })
      }

      handleChangeExtraSlideOldPercent = (event) => {
            this.setState({ bodycar_extra_slideold_percent: event })
      }

      handleChangeSlidePricePercent = (event) => {
            this.setState({ bodycar_slideprice_percent: event })
      }

      handleChangeSlideDiscMinPercent = (event) => {
            this.setState({ bodycar_slidedisc_minpercent: event })
      }

      handleChangeSlideDiscMaxPercent = (event) => {
            this.setState({ bodycar_slidedisc_maxpercent: event })
      }

      handleChangeSlideDiscMinInsalmentPercent = (event) => {
            this.setState({ bodycar_slidedisc_instalment_minpercent: event })
      }

      handleChangeSlideDiscMaxInsalmentPercent = (event) => {
            this.setState({ bodycar_slidedisc_instalment_maxpercent: event })
      }

      handleSelectRows = (row2) => {
            this.getBodyCarCovarage(row2.bodycar_price_id)
            this.getBodyCarDiscSlideold(row2.bodycar_price_id)
            this.getBodyCarExtraSlideold(row2.bodycar_price_id)
            this.getBodyCarSlideprice(row2.bodycar_price_id)
            this.getBodyCarSlideDisc(row2.bodycar_price_id)
            this.getBodyCarDiscntLife(row2.bodycar_price_id)
            this.getBodyCarDiscbody(row2.bodycar_price_id)
            this.getBodyCarThirdparty(row2.bodycar_price_id)
            this.getBodyCarAccBank(row2.bodycar_price_id)
            this.getBodyCarAnother(row2.bodycar_price_id)
            this.getBodyCarPriority(row2.bodycar_price_id)
            this.getoptionBodycarExceptions(row2.bodycar_price_cargroup_id)
            this.getBodyCarExceptions(row2.bodycar_price_id)
            this.getoptionBodycarExtracar(row2.bodycar_price_car_mode_id)
            this.getBodyCarExtracar(row2.bodycar_price_id)
            this.getBodyCarUsefor(row2.bodycar_price_id)
            this.getoptionBodycarUsefor(row2.bodycar_price_car_mode_id)

            this.setState(
                  {
                        bodycar_price_id: row2.bodycar_price_id,

                        selectedCompany: { value: row2.bodycar_price_fieldcompany_id, label: row2.company_name, logo: row2.company_logo_url },
                        selectedCarmode: { value: row2.bodycar_price_car_mode_id, label: row2.carmode_name },
                        selectedCargroup: { value: row2.bodycar_price_cargroup_id, label: row2.cargroup_name },
                        bodycar_price_import_year: row2.bodycar_price_import_year,
                        bodycar_price_import_percent: row2.bodycar_price_import_percent,
                        bodycar_price_new_percent: row2.bodycar_price_new_percent,
                        bodycar_price_min_disc: row2.bodycar_price_min_disc,
                        bodycar_price_max_disc: row2.bodycar_price_max_disc,
                        bodycar_price_fixed_amount: row2.bodycar_price_fixed_amount,
                        bodycar_price_fixed_transportation: row2.bodycar_price_fixed_transportation,
                        bodycar_price_min_price: row2.bodycar_price_min_price,
                        bodycar_price_max_price: row2.bodycar_price_max_price,
                        bodycar_price_chash: row2.bodycar_price_chash,
                        bodycar_price_non_fabric: row2.bodycar_price_non_fabric,
                        selectedUserforCalculate: optionStep[row2.bodycar_price_usefor_calmode_id],
                        selectedCovrageCalculate: optionStep[row2.bodycar_price_covarage_calmode_id],

                        bodycar_price_deactive: row2.bodycar_price_deactive,
                        bodycar_price_together_disc: row2.bodycar_price_together_disc,
                        bodycar_price_no_discount_on_transport: row2.bodycar_price_no_discount_on_transport,
                        bodycar_price_no_damage_discount_on_transport: row2.bodycar_price_no_damage_discount_on_transport,
                        bodycar_price_robonbaseprice: row2.bodycar_price_robonbaseprice,
                        bodycar_price_stairs: row2.bodycar_price_stairs,
                        company_logo_url: row2.company_logo_url,
                        newPriceBodyCar: false,
                  },
                  () => {}
            )
      }
      newPriceBodyCar = (event) => {
            this.setState({
                  bodycar_price_id: "",
                  selectedCompany: "",
                  selectedCarmode: "",
                  selectedCargroup: "",
                  bodycar_price_import_year: 0,
                  bodycar_price_import_percent: 0,
                  bodycar_price_new_percent: 0,
                  bodycar_price_min_disc: 0,
                  bodycar_price_max_disc: 0,
                  bodycar_price_fixed_amount: 0,
                  bodycar_price_fixed_transportation: 0,
                  bodycar_price_min_price: 0,
                  bodycar_price_max_price: 0,
                  bodycar_price_chash: 0,
                  bodycar_price_non_fabric: 0,
                  bodycar_price_deactive: "0",
                  bodycar_price_together_disc: "0",
                  bodycar_price_no_discount_on_transport: "0",
                  bodycar_price_no_damage_discount_on_transport: "0",
                  bodycar_price_robonbaseprice: "0",
                  bodycar_price_stairs: "0",
                  company_logo_url: "",
                  selectedUserforCalculate: optionStep[2],
                  selectedCovrageCalculate: optionStep[2],
                  newPriceBodyCar: true,
            })
      }
      handleUseforCalculate = (selectedUserforCalculate) => {
            this.setState({ selectedUserforCalculate: selectedUserforCalculate })
      }
      handleCovarageCalculate = (selectedCovrageCalculate) => {
            this.setState({ selectedCovrageCalculate: selectedCovrageCalculate })
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getPriceBodyCar()
                                    self.getoptionCompany()
                                    self.getoptionCarmode()
                                    self.getoptionBodycarCovarage()
                                    self.getoptionBodycarDiscntLife()
                                    self.getoptionBodycarDiscbody()
                                    self.getoptionBodycarThirdparty()
                                    self.getoptionBodycarAccBank()
                                    self.getoptionBodycarAnother()
                                    self.getoptionBodycarPriority()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }
      deletePriceBody = () => {
            const { bodycar_price_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.handleClose()
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getPriceBodyCar()
                              self.newPriceBodyCar()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_bodycar_price")
            fd.append("bodycar_price_id", bodycar_price_id)

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getPriceBodyCar() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_bodycar_price")

            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      getBodyCarCovarage(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarCovarage: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ bodycarCovarage: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_coverage")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarUsefor(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarUsefor: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ bodycarUsefor: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_usefor")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarDiscntLife(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarDiscntLife: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ bodycarDiscntLife: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_discntlife")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }
      getBodyCarDiscbody(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarDiscbody: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              console.log(this.responseText)
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ bodycarDiscbody: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_pricediscbody")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarThirdparty(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarThirdparty: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ bodycarThirdparty: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_pricethirdparty")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarExceptions(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarExceptions: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ bodycarExceptions: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_exceptions")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarExtracar(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarExtracar: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ bodycarExtracar: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_price_extracar")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarAccBank(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarAccBank: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)

                              if (arr.result === "ok") {
                                    self.setState({ bodycarAccBank: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_priceaccbank")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarAnother(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarAnother: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)

                              if (arr.result === "ok") {
                                    self.setState({ bodycarAnother: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_priceanother")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarPriority(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ bodycarPriority: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)

                              if (arr.result === "ok") {
                                    self.setState({ bodycarPriority: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_pricepriority")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarSlideDisc(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            this.setState({ bodyCarSlideDisc: [] }, () => {
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ bodyCarSlideDisc: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_bodycar_slidedisc")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarDiscSlideold(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            this.setState({ bodyCarDiscSlideOld: [] }, () => {
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState(
                                          {
                                                bodyCarDiscSlideOld: arr.data,
                                          },
                                          () => {}
                                    )
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_bodycar_disc_slideold")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarExtraSlideold(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            this.setState({ bodyCarExtraSlideOld: [] }, () => {
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState(
                                          {
                                                bodyCarExtraSlideOld: arr.data,
                                          },
                                          () => {}
                                    )
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_bodycar_extra_slideold")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getBodyCarSlideprice(bodycar_price_id) {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            this.setState({ bodyCarSlidePrice: [] }, () => {
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState(
                                          {
                                                bodyCarSlidePrice: arr.data,
                                          },
                                          () => {}
                                    )
                              } else if (arr.result === "error") {
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_bodycar_slideprice")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].fieldcompany_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company, selectedCompany: Company[0] }, () => {
                                    self.filterPriceBodyCar()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_fieldcompany")
            fd.append("fieldinsurance", "bodycarins")
            xhttp.open("POST", `${constants.BASE_URL}/fieldcompany`)
            xhttp.send(fd)
      }

      getoptionCarmode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].carmode_id, label: arr.data[k].carmode_name })
                              }
                              self.setState({ optionCarmode: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_carmode")
            fd.append("fieldinsurance", "thirdpartyins")
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getoptionBodycarCovarage = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_coverage_id, label: arr.data[k].bodycar_coverage_name })
                              }
                              self.setState({ optionBodycarCovarage: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_coverage")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      getoptionBodycarUsefor = (bodycar_price_car_mode_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_usefor_id, label: arr.data[k].bodycar_usefor_name })
                              }
                              self.setState({ optionBodycarUsefor: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_usefor")
            if (bodycar_price_car_mode_id) {
                  fd.append("carmode_id", bodycar_price_car_mode_id)
            }
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      getoptionBodycarDiscntLife = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_discnt_life_id, label: arr.data[k].bodycar_discnt_life_company_name })
                              }
                              self.setState({ optionBodycarDiscntLife: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_bodycar_discntlife")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      getoptionBodycarDiscbody = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_discnt_id, label: arr.data[k].bodycar_discnt_name })
                              }
                              self.setState({ optionBodycarDiscbody: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discnt_bodycar")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      getoptionBodycarThirdparty = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].bodycar_discnt_thirdparty_id,
                                          label: arr.data[k].bodycar_discnt_thirdparty_name,
                                    })
                              }
                              self.setState({ optionBodycarThirdparty: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discnt_thirdparty")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      getoptionBodycarExceptions = (cargroup_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].car_id, label: arr.data[k].car_name })
                              }
                              self.setState({ optionBodycarExceptions: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_car")
            fd.append("car_group_id", cargroup_id)
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getoptionBodycarExtracar = (carmode_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].car_id, label: arr.data[k].car_name })
                              }
                              self.setState({ optionBodycarExtracar: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_car")
            fd.append("car_mode_id", carmode_id)
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getoptionBodycarAnother = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_discnt_another_id, label: arr.data[k].bodycar_discnt_another_name })
                              }
                              self.setState({ optionBodycarAnother: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discnt_another")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      getoptionBodycarPriority = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_discnt_priority_id, label: arr.data[k].bodycar_discnt_priority_name })
                              }
                              self.setState({ optionBodycarPriority: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discnt_priority")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      getoptionBodycarAccBank = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].bodycar_discnt_accbank_id, label: arr.data[k].bodycar_discnt_accbank_name })
                              }
                              self.setState({ optionBodycarAccBank: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_discnt_accbank")
            xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
            xhttp.send(fd)
      }

      getoptionCargroup = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].cargroup_id, label: arr.data[k].cargroup_name })
                              }
                              self.setState({ optionCargroup: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_cargroup")
            fd.append("carmode_id", this.state.selectedCarmode.value)
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      saveNewPriceBodyCar = () => {
            const {
                  bodycar_price_import_year,
                  bodycar_price_import_percent,
                  bodycar_price_new_percent,
                  bodycar_price_min_disc,
                  bodycar_price_max_disc,
                  bodycar_price_fixed_amount,
                  bodycar_price_fixed_transportation,
                  bodycar_price_min_price,
                  bodycar_price_max_price,
                  bodycar_price_chash,
                  bodycar_price_non_fabric,
                  selectedCompany,
                  selectedCarmode,
                  selectedCargroup,
                  bodycar_price_deactive,
                  bodycar_price_together_disc,
                  bodycar_price_no_discount_on_transport,
                  bodycar_price_no_damage_discount_on_transport,
                  bodycar_price_robonbaseprice,
                  bodycar_price_stairs,
            } = this.state
            if (selectedCompany != "" && selectedCarmode != "" && selectedCargroup != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceBodyCar()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_bodycar_price")

                  fd.append("bodycar_price_fieldcompany_id", selectedCompany.value)
                  fd.append("bodycar_price_car_mode_id", selectedCarmode.value)
                  fd.append("bodycar_price_cargroup_id", selectedCargroup.value)
                  fd.append("bodycar_price_deactive", bodycar_price_deactive)
                  fd.append("bodycar_price_together_disc", bodycar_price_together_disc)
                  fd.append("bodycar_price_no_discount_on_transport", bodycar_price_no_discount_on_transport)
                  fd.append("bodycar_price_no_damage_discount_on_transport", bodycar_price_no_damage_discount_on_transport)
                  fd.append("bodycar_price_robonbaseprice", bodycar_price_robonbaseprice)
                  fd.append("bodycar_price_stairs", bodycar_price_stairs)
                  fd.append("bodycar_price_import_year", bodycar_price_import_year)
                  fd.append("bodycar_price_import_percent", bodycar_price_import_percent)
                  fd.append("bodycar_price_new_percent", bodycar_price_new_percent)
                  fd.append("bodycar_price_min_disc", bodycar_price_min_disc)
                  fd.append("bodycar_price_max_disc", bodycar_price_max_disc)
                  fd.append("bodycar_price_fixed_amount", bodycar_price_fixed_amount)
                  fd.append("bodycar_price_fixed_transportation", bodycar_price_fixed_transportation)
                  fd.append("bodycar_price_min_price", bodycar_price_min_price)
                  fd.append("bodycar_price_max_price", bodycar_price_max_price)
                  fd.append("bodycar_price_chash", bodycar_price_chash)
                  fd.append("bodycar_price_non_fabric", bodycar_price_non_fabric)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarCondition = () => {
            const { selectedCovrageCalculate, bodycar_price_id, selectedBodycarCovarage, bodycar_price_covarage_percent } = this.state
            if (selectedBodycarCovarage != "" && bodycar_price_covarage_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_price_covarage_percent: "", selectedBodycarCovarage: "" })
                                    self.getBodyCarCovarage(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_coverage")
                  fd.append("bodycar_price_covarage_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_covarage_percent", bodycar_price_covarage_percent)
                  fd.append("bodycar_price_covarage_bodycoverage_id", selectedBodycarCovarage.value)
                  fd.append("bodycar_price_covarage_calmode_id", selectedCovrageCalculate.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarUsefor = () => {
            const { selectedUserforCalculate, bodycar_price_id, selectedBodycarUsefor, bodycar_price_usefor_percent } = this.state
            if (selectedBodycarUsefor != "" && bodycar_price_usefor_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_price_usefor_percent: "", selectedBodycarUsefor: "" })
                                    self.getBodyCarUsefor(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_usefor")
                  fd.append("bodycar_price_usefor_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_usefor_percent", bodycar_price_usefor_percent)
                  fd.append("bodycar_price_usefor_bodyusefor_id", selectedBodycarUsefor.value)
                  fd.append("bodycar_price_usefor_calmode_id", selectedUserforCalculate.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarDiscntLife = () => {
            const { bodycar_price_id, selectedBodycarDiscntLife, bodycar_price_discntlife_percent } = this.state
            if (selectedBodycarDiscntLife != "" && bodycar_price_discntlife_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_price_discntlife_percent: "", selectedBodycarDiscntLife: "" })
                                    self.getBodyCarDiscntLife(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_discntlife")
                  fd.append("bodycar_price_discntlife_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_discntlife_percent", bodycar_price_discntlife_percent)
                  fd.append("bodycar_price_discntlife_bodycar_discnt_life_id", selectedBodycarDiscntLife.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarDiscbody = () => {
            const { bodycar_price_id, selectedBodycarDiscbody, bodycar_price_discbody_percent } = this.state
            if (selectedBodycarDiscbody != "" && bodycar_price_discbody_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_price_discbody_percent: "", selectedBodycarDiscbody: "" })
                                    self.getBodyCarDiscbody(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_pricediscbody")
                  fd.append("bodycar_price_discbody_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_discbody_percent", bodycar_price_discbody_percent)
                  fd.append("bodycar_price_discbody_bodycar_discnt_id", selectedBodycarDiscbody.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarThirdparty = () => {
            const { bodycar_price_id, selectedBodycarThirdparty, bodycar_price_thirdparty_percent } = this.state
            if (selectedBodycarThirdparty != "" && bodycar_price_thirdparty_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_price_thirdparty_percent: "", selectedBodycarThirdparty: "" })
                                    self.getBodyCarThirdparty(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_pricethirdparty")
                  fd.append("bodycar_price_thirdparty_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_thirdparty_percent", bodycar_price_thirdparty_percent)
                  fd.append("bodycar_price_thirdparty_bodycar_discnt_thirdparty_id", selectedBodycarThirdparty.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarExceptions = () => {
            const { bodycar_price_id, selectedBodycarExceptions } = this.state
            if (selectedBodycarExceptions != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ selectedBodycarExceptions: "" })
                                    self.getBodyCarExceptions(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_exceptions")
                  fd.append("bodycar_price_exceptions_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_exceptions_car_id", selectedBodycarExceptions.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarExtracar = () => {
            const { bodycar_price_id, selectedBodycarExtracar } = this.state
            if (selectedBodycarExtracar != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ selectedBodycarExtracar: "" })
                                    self.getBodyCarExtracar(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_price_extracar")
                  fd.append("bodycar_price_extracar_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_extracar_car_id", selectedBodycarExtracar.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarAccBank = () => {
            const { bodycar_price_id, selectedBodycarAccBank, bodycar_price_accbank_percent } = this.state
            if (selectedBodycarAccBank != "" && bodycar_price_accbank_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_price_accbank_percent: "", selectedBodycarAccBank: "" })
                                    self.getBodyCarAccBank(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_priceaccbank")
                  fd.append("bodycar_price_accbank_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_accbank_percent", bodycar_price_accbank_percent)
                  fd.append("bodycar_price_accbank_bodycar_discnt_accbank_id", selectedBodycarAccBank.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarAnother = () => {
            const { bodycar_price_id, selectedBodycarAnother, bodycar_price_another_percent } = this.state
            if (selectedBodycarAnother != "" && bodycar_price_another_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_price_another_percent: "", selectedBodycarAnother: "" })
                                    self.getBodyCarAnother(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_priceanother")
                  fd.append("bodycar_price_another_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_another_percent", bodycar_price_another_percent)
                  fd.append("bodycar_price_another_bodycar_discnt_another_id", selectedBodycarAnother.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarPriority = () => {
            const { bodycar_price_id, selectedBodycarPriority, bodycar_price_priority_percent } = this.state
            if (selectedBodycarPriority != "" && bodycar_price_priority_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_price_priority_percent: "", selectedBodycarPriority: "" })
                                    self.getBodyCarPriority(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_pricepriority")
                  fd.append("bodycar_price_priority_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_price_priority_percent", bodycar_price_priority_percent)
                  fd.append("bodycar_price_priority_bodycar_discnt_priority_id", selectedBodycarPriority.value)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }
      saveNewDiscSlideOld = () => {
            const { bodycar_price_id, bodycar_disc_slideold_min, bodycar_disc_slideold_max, bodycar_disc_slideold_percent } = this.state
            if ((bodycar_disc_slideold_min != "" || bodycar_disc_slideold_max != "") && bodycar_disc_slideold_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)

                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_disc_slideold_percent: "", bodycar_disc_slideold_min: "", bodycar_disc_slideold_max: "" })
                                    self.getBodyCarDiscSlideold(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_bodycar_disc_slideold")
                  fd.append("bodycar_disc_slideold_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_disc_slideold_percent", bodycar_disc_slideold_percent)
                  fd.append("bodycar_disc_slideold_min", bodycar_disc_slideold_min)
                  fd.append("bodycar_disc_slideold_max", bodycar_disc_slideold_max)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewExtraSlideOld = () => {
            const { bodycar_price_id, bodycar_extra_slideold_min, bodycar_extra_slideold_max, bodycar_extra_slideold_percent } = this.state
            if ((bodycar_extra_slideold_min != "" || bodycar_extra_slideold_max != "") && bodycar_extra_slideold_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)

                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({
                                          bodycar_extra_slideold_percent: "",
                                          bodycar_extra_slideold_min: "",
                                          bodycar_extra_slideold_max: "",
                                    })
                                    self.getBodyCarExtraSlideold(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_bodycar_extra_slideold")
                  fd.append("bodycar_extra_slideold_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_extra_slideold_percent", bodycar_extra_slideold_percent)
                  fd.append("bodycar_extra_slideold_min", bodycar_extra_slideold_min)
                  fd.append("bodycar_extra_slideold_max", bodycar_extra_slideold_max)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceBodyCarTime = () => {
            const { bodycar_price_id, bodycar_slideprice_min, bodycar_slideprice_max, bodycar_slideprice_percent } = this.state
            if ((bodycar_slideprice_min != "" || bodycar_slideprice_max != "") && bodycar_slideprice_percent != "") {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)

                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ bodycar_slideprice_percent: "", bodycar_slideprice_min: "", bodycar_slideprice_max: "" })
                                    self.getBodyCarSlideprice(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_bodycar_slideprice")
                  fd.append("bodycar_slideprice_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_slideprice_percent", bodycar_slideprice_percent)
                  fd.append("bodycar_slideprice_min", bodycar_slideprice_min)
                  fd.append("bodycar_slideprice_max", bodycar_slideprice_max)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewPriceSlideDisc = () => {
            const {
                  bodycar_price_id,
                  bodycar_slidedisc_min,
                  bodycar_slidedisc_max,
                  bodycar_slidedisc_minpercent,
                  bodycar_slidedisc_maxpercent,
                  bodycar_slidedisc_instalment_minpercent,
                  bodycar_slidedisc_instalment_maxpercent,
            } = this.state
            if (
                  (bodycar_slidedisc_min != "" || bodycar_slidedisc_max != "") &&
                  bodycar_slidedisc_minpercent != "" &&
                  bodycar_slidedisc_maxpercent != "" &&
                  bodycar_slidedisc_instalment_minpercent != "" &&
                  bodycar_slidedisc_instalment_maxpercent != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)

                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({
                                          bodycar_slidedisc_minpercent: "",
                                          bodycar_slidedisc_maxpercent: "",
                                          bodycar_slidedisc_instalment_minpercent: "",
                                          bodycar_slidedisc_instalment_maxpercent: "",
                                          bodycar_slidedisc_min: "",
                                          bodycar_slidedisc_max: "",
                                    })
                                    self.getBodyCarSlideDisc(bodycar_price_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_bodycar_slidedisc")
                  fd.append("bodycar_slidedisc_bodycar_price_id", bodycar_price_id)
                  fd.append("bodycar_slidedisc_minpercent", bodycar_slidedisc_minpercent)
                  fd.append("bodycar_slidedisc_maxpercent", bodycar_slidedisc_maxpercent)
                  fd.append("bodycar_slidedisc_instalment_minpercent", bodycar_slidedisc_instalment_minpercent)
                  fd.append("bodycar_slidedisc_instalment_maxpercent", bodycar_slidedisc_instalment_maxpercent)
                  fd.append("bodycar_slidedisc_min", bodycar_slidedisc_min)
                  fd.append("bodycar_slidedisc_max", bodycar_slidedisc_max)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد زمان بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      changePriceBodyCar = () => {
            const {
                  bodycar_price_id,
                  bodycar_price_import_year,
                  bodycar_price_import_percent,
                  bodycar_price_new_percent,
                  bodycar_price_min_disc,
                  bodycar_price_max_disc,
                  bodycar_price_fixed_amount,
                  bodycar_price_fixed_transportation,
                  bodycar_price_min_price,
                  bodycar_price_max_price,
                  bodycar_price_chash,
                  bodycar_price_non_fabric,
                  selectedCompany,
                  selectedCarmode,
                  selectedCargroup,
                  bodycar_price_deactive,
                  bodycar_price_stairs,
                  bodycar_price_robonbaseprice,
                  bodycar_price_together_disc,
                  bodycar_price_no_discount_on_transport,
                  bodycar_price_no_damage_discount_on_transport,
            } = this.state
            if (
                  selectedCompany != "" &&
                  selectedCarmode != "" &&
                  selectedCargroup != "" &&
                  bodycar_price_import_year != "" &&
                  bodycar_price_import_percent != "" &&
                  bodycar_price_new_percent != "" &&
                  bodycar_price_min_disc != "" &&
                  bodycar_price_max_disc != "" &&
                  bodycar_price_fixed_amount != "" &&
                  bodycar_price_fixed_transportation != "" &&
                  bodycar_price_min_price != "" &&
                  bodycar_price_max_price != ""
            ) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getPriceBodyCar()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "modify_bodycar_price")
                  fd.append("bodycar_price_id", bodycar_price_id)

                  fd.append("bodycar_price_fieldcompany_id", selectedCompany.value)
                  fd.append("bodycar_price_car_mode_id", selectedCarmode.value)
                  fd.append("bodycar_price_cargroup_id", selectedCargroup.value)
                  fd.append("bodycar_price_deactive", bodycar_price_deactive)
                  fd.append("bodycar_price_robonbaseprice", bodycar_price_robonbaseprice)
                  fd.append("bodycar_price_together_disc", bodycar_price_together_disc)
                  fd.append("bodycar_price_no_discount_on_transport", bodycar_price_no_discount_on_transport)
                  fd.append("bodycar_price_no_damage_discount_on_transport", bodycar_price_no_damage_discount_on_transport)
                  fd.append("bodycar_price_stairs", bodycar_price_stairs)
                  fd.append("bodycar_price_import_year", bodycar_price_import_year)
                  fd.append("bodycar_price_import_percent", bodycar_price_import_percent)
                  fd.append("bodycar_price_new_percent", bodycar_price_new_percent)
                  fd.append("bodycar_price_min_disc", bodycar_price_min_disc)
                  fd.append("bodycar_price_max_disc", bodycar_price_max_disc)
                  fd.append("bodycar_price_fixed_amount", bodycar_price_fixed_amount)
                  fd.append("bodycar_price_fixed_transportation", bodycar_price_fixed_transportation)
                  fd.append("bodycar_price_min_price", bodycar_price_min_price)
                  fd.append("bodycar_price_max_price", bodycar_price_max_price)
                  fd.append("bodycar_price_chash", bodycar_price_chash)
                  fd.append("bodycar_price_non_fabric", bodycar_price_non_fabric)

                  xhttp.open("POST", `${constants.BASE_URL}/bodycar`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات قیمت شرکت بیمه را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }
      filterPriceBodyCar = () => {
            const { selectedCompany, selectedCarmode, requestinfos } = this.state
            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedCompany === "" ||
                              selectedCompany.value === 0 ||
                              temparray[i].bodycar_price_fieldcompany_id === selectedCompany.value) &&
                        (selectedCarmode === "" || selectedCarmode.value === 0 || temparray[i].bodycar_price_car_mode_id === selectedCarmode.value)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  selectedUserforCalculate,
                  selectedCovrageCalculate,
                  bodycar_price_import_year,
                  bodycar_price_import_percent,
                  bodycar_price_new_percent,
                  bodycar_price_min_disc,
                  bodycar_price_max_disc,
                  bodycar_price_fixed_amount,
                  bodycar_price_fixed_transportation,
                  bodycar_price_min_price,
                  bodycar_price_max_price,
                  bodycar_price_chash,
                  bodycar_price_non_fabric,
                  bodycar_price_discntlife_percent,
                  bodycar_price_thirdparty_percent,
                  bodycar_price_discbody_percent,
                  bodycar_price_accbank_percent,
                  bodycar_price_another_percent,
                  bodycar_price_priority_percent,
                  bodycar_price_covarage_percent,
                  bodycar_price_usefor_percent,
                  bodycar_disc_slideold_percent,
                  bodycar_extra_slideold_percent,
                  bodycar_slideprice_percent,
                  bodycar_slidedisc_minpercent,
                  bodycar_slidedisc_maxpercent,
                  bodycar_slidedisc_instalment_minpercent,
                  bodycar_slidedisc_instalment_maxpercent,
                  selectedBodycarCovarage,
                  selectedBodycarUsefor,
                  selectedBodycarDiscntLife,
                  selectedBodycarDiscbody,
                  selectedBodycarThirdparty,
                  selectedBodycarExceptions,
                  selectedBodycarExtracar,
                  selectedBodycarAccBank,
                  selectedBodycarAnother,
                  selectedBodycarPriority,
                  bodycar_disc_slideold_min,
                  bodycar_disc_slideold_max,
                  bodycar_extra_slideold_min,
                  bodycar_extra_slideold_max,
                  bodycar_slideprice_min,
                  bodycar_slideprice_max,
                  bodycar_slidedisc_min,
                  bodycar_slidedisc_max,
                  optionCompany,
                  optionBodycarCovarage,
                  optionBodycarUsefor,
                  optionBodycarDiscntLife,
                  optionBodycarDiscbody,
                  optionBodycarThirdparty,
                  optionBodycarExceptions,
                  optionBodycarExtracar,
                  optionBodycarAccBank,
                  optionBodycarAnother,
                  optionBodycarPriority,
                  optionCarmode,
                  optionCargroup,
                  bodycarCovarage,
                  bodycarUsefor,
                  bodycarDiscntLife,
                  bodycarDiscbody,
                  bodycarThirdparty,
                  bodycarExceptions,
                  bodycarExtracar,
                  bodycarAccBank,
                  bodycarAnother,
                  bodycarPriority,
                  bodyCarSlidePrice,
                  bodyCarDiscSlideOld,
                  bodyCarExtraSlideOld,
                  bodyCarSlideDisc,
                  snackMode,
                  snackstr,
                  showSnack,
                  newPriceBodyCar,
                  bodycar_price_id,
                  company_logo_url,
                  selectedCompany,
                  selectedCarmode,
                  selectedCargroup,
                  bodycar_price_deactive,
                  bodycar_price_together_disc,
                  bodycar_price_no_discount_on_transport,
                  bodycar_price_no_damage_discount_on_transport,
                  bodycar_price_robonbaseprice,
                  bodycar_price_stairs,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"شماره قیمت بیمه بدنه: " + bodycar_price_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={this.state.selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نوع اتوموبیل </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع اتوموبیل "}
                                                                              value={selectedCarmode}
                                                                              onChange={this.handleCarmode}
                                                                              options={optionCarmode}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">گروه اتوموبیل </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع اتوموبیل "}
                                                                              value={selectedCargroup}
                                                                              onChange={this.handleCargroup}
                                                                              options={optionCargroup}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="عمر اتوموبیل وارداتی"
                                                                        handleInputt={this.handleChangeImportYear}
                                                                        value={bodycar_price_import_year}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="درصد تخفیف اتوموبیل وارداتی"
                                                                        handleInputt={this.handleChangeImportPercent}
                                                                        value={bodycar_price_import_percent}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="درصد تخفیف صفر کیلومتر "
                                                                        handleInputt={this.handleChangeNewPercent}
                                                                        value={bodycar_price_new_percent}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="حداقل تخفیف"
                                                                        handleInputt={this.handleChangeMinDisc}
                                                                        value={bodycar_price_min_disc}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        placeholder="حداکثر تخفیف"
                                                                        handleInputt={this.handleChangeMaxDisc}
                                                                        value={bodycar_price_max_disc}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="ملبغ ثابت حق بیمه "
                                                                        handleInputt={this.handleChangeFixAmount}
                                                                        value={bodycar_price_fixed_amount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="ملبغ ثابت ایاب ذهاب"
                                                                        handleInputt={this.handleChangeFixTransportation}
                                                                        value={bodycar_price_fixed_transportation}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="حداقل قیمت اتوموبیل"
                                                                        handleInputt={this.handleChangeMinPrice}
                                                                        value={bodycar_price_min_price}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        type="currency"
                                                                        placeholder="حداکثر قیمت اتوموبیل"
                                                                        handleInputt={this.handleChangeMaxPrice}
                                                                        value={bodycar_price_max_price}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        type="percent"
                                                                        placeholder="تخفیف نقدی"
                                                                        handleInputt={this.handleChangeCash}
                                                                        value={bodycar_price_chash}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <FloatingLabelInput
                                                                        type="percent"
                                                                        type="percent"
                                                                        placeholder="لوازم غیر فابریک"
                                                                        handleInputt={this.handleChangeNonFabric}
                                                                        value={bodycar_price_non_fabric}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={bodycar_price_stairs === "0" ? false : true}
                                                                                          onChange={this.handleChangeStairs}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="حداکثر تخفبف با احتساب تخفیف نقدی "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={
                                                                                                bodycar_price_robonbaseprice === "0" ? false : true
                                                                                          }
                                                                                          onChange={this.handleChangeRobonBasePrice}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="اعمال تخفیف ثالث فقط برای خود شرکت"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={bodycar_price_together_disc === "0" ? false : true}
                                                                                          onChange={this.handleChangeTogether_disc}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label=" تخفیف عدم خسارت ثالث و بدنه همزمان"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                  <Switch
                                                                                      checked={bodycar_price_no_discount_on_transport === "0" ? false : true}
                                                                                      onChange={this.handleChangeNoDiscountOnTransport}
                                                                                      name="gilad"
                                                                                  />
                                                                            }
                                                                            label="عدم اعمال تخفیف روی ایاب ذهاب"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={bodycar_price_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت قیمت شرکت بیمه"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                            control={
                                                                                  <Switch
                                                                                      checked={bodycar_price_no_damage_discount_on_transport === "0" ? false : true}
                                                                                      onChange={this.handleChangeNoDamageDiscountOnTransport}
                                                                                      name="gilad"
                                                                                  />
                                                                            }
                                                                            label="عدم اعمال تخفیف عدم خسارت روی ایاب ذهاب"
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={12} style={{ textAlign: "center", marginBottom: "20px" }}>
                                                                  {newPriceBodyCar ? (
                                                                        <Button
                                                                              style={{ justifyContent: "center" }}
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.saveNewPriceBodyCar}
                                                                        >
                                                                              {"ثبت قیمت بیمه بدنه جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newPriceBodyCar}
                                                                              >
                                                                                    {"قیمت بیمه بدنه جدید "}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.changePriceBodyCar}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.handleClickOpen()
                                                                                    }}
                                                                              >
                                                                                    {" حذف قیمت بیمه بدنه"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            {newPriceBodyCar ? null : (
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                            )}
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  {bodycarCovarage.map((bodycarCovarage, index) => (
                                                                        <BodyCarCovarage
                                                                              bodycarCovarage={bodycarCovarage}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={4}>
                                                                              <div>
                                                                                    <label className="on"> پوشش بدنه </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"پوشش بدنه "}
                                                                                          value={selectedBodycarCovarage}
                                                                                          onChange={this.handleBodycarCovarage}
                                                                                          options={optionBodycarCovarage}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد پوشش بدنه"
                                                                                    handleInputt={this.handleChangeBodyCarCovaragePrice}
                                                                                    value={bodycar_price_covarage_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item xs={3}>
                                                                              <div>
                                                                                    <label className="on">فیلد مورد محاسبه</label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"فیلد مورد محاسبه"}
                                                                                          value={selectedCovrageCalculate}
                                                                                          onChange={this.handleCovarageCalculate}
                                                                                          options={optionStep}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarCondition}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  {bodycarUsefor.map((bodycarUsefor, index) => (
                                                                        <BodyCarUsefor
                                                                              bodycar_price_car_mode_id={selectedCarmode.value}
                                                                              bodycarUsefor={bodycarUsefor}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={4}>
                                                                              <div>
                                                                                    <label className="on">مورد استفاده </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"مورد استفاده"}
                                                                                          value={selectedBodycarUsefor}
                                                                                          onChange={this.handleBodycarUsefor}
                                                                                          options={optionBodycarUsefor}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد  مورد استفاده"
                                                                                    handleInputt={this.handleChangeBodyCarUseforPrice}
                                                                                    value={bodycar_price_usefor_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item xs={3}>
                                                                              <div>
                                                                                    <label className="on">فیلد مورد محاسبه</label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"فیلد مورد محاسبه"}
                                                                                          value={selectedUserforCalculate}
                                                                                          onChange={this.handleUseforCalculate}
                                                                                          options={optionStep}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarUsefor}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {bodyCarDiscSlideOld.map((bodyCarDiscSlideOld, index) => (
                                                                        <BodyCarDiscSlideOld
                                                                              bodyCarDiscSlideOld={bodyCarDiscSlideOld}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="از سال"
                                                                                    handleInputt={this.handleDiscSlideOldMin}
                                                                                    value={bodycar_disc_slideold_min}
                                                                              />
                                                                        </Grid>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="تا سال"
                                                                                    handleInputt={this.handleDiscSlideOldMax}
                                                                                    value={bodycar_disc_slideold_max}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="درصد تخفیف"
                                                                                    handleInputt={this.handleChangeDiscSlideOldPercent}
                                                                                    value={bodycar_disc_slideold_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewDiscSlideOld}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {bodyCarExtraSlideOld.map((bodyCarExtraSlideOld, index) => (
                                                                        <BodyCarExtraSlideOld
                                                                              bodyCarExtraSlideOld={bodyCarExtraSlideOld}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="از سال"
                                                                                    handleInputt={this.handleExtraSlideOldMin}
                                                                                    value={bodycar_extra_slideold_min}
                                                                              />
                                                                        </Grid>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="تا سال"
                                                                                    handleInputt={this.handleExtraSlideOldMax}
                                                                                    value={bodycar_extra_slideold_max}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="درصد اضافه نرخ"
                                                                                    handleInputt={this.handleChangeExtraSlideOldPercent}
                                                                                    value={bodycar_extra_slideold_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewExtraSlideOld}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {bodyCarSlidePrice.map((bodyCarSlidePrice, index) => (
                                                                        <BodyCarSlidePrice
                                                                              bodyCarSlidePrice={bodyCarSlidePrice}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="حد پایین"
                                                                                    handleInputt={this.handleSlidePriceMin}
                                                                                    value={bodycar_slideprice_min}
                                                                              />
                                                                        </Grid>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="حد بالا"
                                                                                    handleInputt={this.handleSlidePriceMax}
                                                                                    value={bodycar_slideprice_max}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="در هزار"
                                                                                    handleInputt={this.handleChangeSlidePricePercent}
                                                                                    value={bodycar_slideprice_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarTime}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12} style={{ backgroundColor: "#cfe8fc" }}>
                                                                  {bodyCarSlideDisc.map((bodyCarSlideDisc, index) => (
                                                                        <BodyCarSlideDisc
                                                                              bodyCarSlideDisc={bodyCarSlideDisc}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>
                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="حد پایین"
                                                                                    handleInputt={this.handleSlideDiscPriceMin}
                                                                                    value={bodycar_slidedisc_min}
                                                                              />
                                                                        </Grid>
                                                                        <Grid item xs={3}>
                                                                              <FloatingLabelInput
                                                                                    type="currency"
                                                                                    placeholder="حد بالا"
                                                                                    handleInputt={this.handleSlideDiscPriceMax}
                                                                                    value={bodycar_slidedisc_max}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="حداقل تخفیف"
                                                                                    handleInputt={this.handleChangeSlideDiscMinPercent}
                                                                                    value={bodycar_slidedisc_minpercent}
                                                                              />
                                                                        </Grid>
                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="حداکثر تخفیف"
                                                                                    handleInputt={this.handleChangeSlideDiscMaxPercent}
                                                                                    value={bodycar_slidedisc_maxpercent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="حداقل تخفیف اقساط"
                                                                                    handleInputt={this.handleChangeSlideDiscMinInsalmentPercent}
                                                                                    value={bodycar_slidedisc_instalment_minpercent}
                                                                              />
                                                                        </Grid>
                                                                        <Grid item item xs={2}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="حداکثر تخفیف اقساط"
                                                                                    handleInputt={this.handleChangeSlideDiscMaxInsalmentPercent}
                                                                                    value={bodycar_slidedisc_instalment_maxpercent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={2}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceSlideDisc}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  {bodycarDiscntLife.map((bodycarDiscntLife, index) => (
                                                                        <BodyCarDiscntLife
                                                                              bodycarDiscntLife={bodycarDiscntLife}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> شرکت بیمه عمر </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"شرکت بیمه عمر "}
                                                                                          value={selectedBodycarDiscntLife}
                                                                                          onChange={this.handleBodycarDiscntLife}
                                                                                          options={optionBodycarDiscntLife}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد تخفیف بیمه عمر "
                                                                                    handleInputt={this.handleChangeBodyCarDiscntLifePrice}
                                                                                    value={bodycar_price_discntlife_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarDiscntLife}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  {bodycarThirdparty.map((bodycarThirdparty, index) => (
                                                                        <BodyCarThirdparty
                                                                              bodycarThirdparty={bodycarThirdparty}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> تخفیف بیمه ثالث</label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"تخفیف بیمه ثالث"}
                                                                                          value={selectedBodycarThirdparty}
                                                                                          onChange={this.handleBodycarThirdparty}
                                                                                          options={optionBodycarThirdparty}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد تخفیف ثالث روی تخفیف بیمه بدنه "
                                                                                    handleInputt={this.handleChangeBodyCarThirdpartyPrice}
                                                                                    value={bodycar_price_thirdparty_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarThirdparty}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  {bodycarDiscbody.map((bodycarDiscbody, index) => (
                                                                        <BodyCarDiscbody
                                                                              bodycarDiscbody={bodycarDiscbody}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> تخفیف عدم خسارت بیمه بدنه</label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={" تخفیف عدم خسارت بیمه بدنه"}
                                                                                          value={selectedBodycarDiscbody}
                                                                                          onChange={this.handleBodycarDiscbody}
                                                                                          options={optionBodycarDiscbody}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد  تخفیف عدم خسارت بیمه بدنه "
                                                                                    handleInputt={this.handleChangeBodyCarDiscbodyPrice}
                                                                                    value={bodycar_price_discbody_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarDiscbody}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  {bodycarAccBank.map((bodycarAccBank, index) => (
                                                                        <BodyCarAccBank
                                                                              bodycarAccBank={bodycarAccBank}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> بانک های طرف قرارداد </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"بانک های طرف قرارداد "}
                                                                                          value={selectedBodycarAccBank}
                                                                                          onChange={this.handleBodycarAccBank}
                                                                                          options={optionBodycarAccBank}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد تخفیف حساب بلند مدت بانکی "
                                                                                    handleInputt={this.handleChangeBodyCarAccBankPrice}
                                                                                    value={bodycar_price_accbank_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarAccBank}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  {bodycarAnother.map((bodycarAnother, index) => (
                                                                        <BodyCarAnother
                                                                              bodycarAnother={bodycarAnother}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> تخفیف های متفرقه </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"تخفیف های متفرقه "}
                                                                                          value={selectedBodycarAnother}
                                                                                          onChange={this.handleBodycarAnother}
                                                                                          options={optionBodycarAnother}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="percent"
                                                                                    placeholder="درصد تخفیف های متفرقه "
                                                                                    handleInputt={this.handleChangeBodyCarAnotherPrice}
                                                                                    value={bodycar_price_another_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarAnother}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  {bodycarPriority.map((bodycarPriority, index) => (
                                                                        <BodyCarPriority
                                                                              bodycarPriority={bodycarPriority}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> نام تخفیف </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"نام تخفیف "}
                                                                                          value={selectedBodycarPriority}
                                                                                          onChange={this.handleBodycarPriority}
                                                                                          options={optionBodycarPriority}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={4}>
                                                                              <FloatingLabelInput
                                                                                    type="number"
                                                                                    placeholder="اولویت محاسبه تخفیف "
                                                                                    handleInputt={this.handleChangeBodyCarPriorityPrice}
                                                                                    value={bodycar_price_priority_percent}
                                                                              />
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarPriority}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper style={{ backgroundColor: "#cfe8fc" }} className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid container spacing={3}>
                                                                  {bodycarExceptions.map((bodycarExceptions, index) => (
                                                                        <BodyCarExceptions
                                                                              bodycarExceptions={bodycarExceptions}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> استثتاعات </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"استثتاعات"}
                                                                                          value={selectedBodycarExceptions}
                                                                                          onChange={this.handleBodycarExceptions}
                                                                                          options={optionBodycarExceptions}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarExceptions}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                          <Container>
                                                <Paper
                                                      style={{
                                                            backgroundColor: "#cfe8fc",
                                                            maxHeight: "300px",
                                                            overflowY: "scroll",
                                                            overflowX: "hidden",
                                                      }}
                                                      className={classes.root}
                                                >
                                                      {newPriceBodyCar ? null : (
                                                            <Grid container spacing={3}>
                                                                  {bodycarExtracar.map((bodycarExtracar, index) => (
                                                                        <BodyCarExtracar
                                                                              bodycarExtracar={bodycarExtracar}
                                                                              props={this.props}
                                                                              key={index}
                                                                        />
                                                                  ))}
                                                            </Grid>
                                                      )}
                                                </Paper>

                                                <Paper className={classes.root}>
                                                      {newPriceBodyCar ? null : (
                                                            <Grid item xs={12}>
                                                                  <Grid container spacing={3}>
                                                                        <Grid item xs={5}>
                                                                              <div>
                                                                                    <label className="on"> خودرو های اضافه </label>
                                                                                    <Select
                                                                                          isSearchable={true}
                                                                                          className="adapter-txtsize"
                                                                                          placeholder={"خودرو های اضافه "}
                                                                                          value={selectedBodycarExtracar}
                                                                                          onChange={this.handleBodycarExtracar}
                                                                                          options={optionBodycarExtracar}
                                                                                    />
                                                                              </div>
                                                                        </Grid>

                                                                        <Grid item item xs={3}>
                                                                              <div style={{ width: "100%", textAlign: "left" }}>
                                                                                    <Fab
                                                                                          className={classes.small}
                                                                                          color="primary"
                                                                                          aria-label="add"
                                                                                          onClick={this.saveNewPriceBodyCarExtracar}
                                                                                    >
                                                                                          <AddIcon />
                                                                                    </Fab>
                                                                              </div>
                                                                        </Grid>
                                                                  </Grid>
                                                            </Grid>
                                                      )}
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"bodycar_price_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "bodycar_price_id" ? order : false}
                                                                              >
                                                                                    {" آی دی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "bodycar_price_id"}
                                                                                          direction={orderBy === "bodycar_price_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("bodycar_price_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"bodycar_price_car_mode_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نوع اتوموبیل"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "bodycar_price_car_mode_id"}
                                                                                          direction={
                                                                                                orderBy === "bodycar_price_car_mode_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("bodycar_price_car_mode_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"bodycar_price_cargroup_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"گروه خودرو"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "bodycar_price_cargroup_id"}
                                                                                          direction={
                                                                                                orderBy === "bodycar_price_cargroup_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("bodycar_price_cargroup_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"bodycar_price_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت قیمت بیمه بدنه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "bodycar_price_deactive"}
                                                                                          direction={
                                                                                                orderBy === "bodycar_price_deactive" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("bodycar_price_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["bodycar_price_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell key={"bodycar_price_id"} align={"center"}>
                                                                                                      {row["bodycar_price_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"company_name"} align={"center"}>
                                                                                                      {row["company_name"]}
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["company_logo_url"]}
                                                                                                      />
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"bodycar_price_car_mode_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["carmode_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"bodycar_price_cargroup_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["cargroup_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"bodycar_price_deactive"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["bodycar_price_deactive"] === "1" ||
                                                                                                      row["bodycar_price_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                              <Dialog
                                    open={this.state.openDialog}
                                    onClose={this.handleClose}
                                    aria-labelledby="alert-dialog-title"
                                    aria-describedby="alert-dialog-description"
                              >
                                    <DialogTitle id="alert-dialog-title">{"آیا میخواهید قیمت بیمه بدنه را حذف نمایید"}</DialogTitle>
                                    <DialogContent>
                                          <DialogContentText id="alert-dialog-description">
                                                ابتدا از عملیات خود مطمئن شوید و سپس پاک کنید
                                          </DialogContentText>
                                    </DialogContent>
                                    <DialogActions>
                                          <Button onClick={this.handleClose} color="primary">
                                                انصراف
                                          </Button>
                                          <Button onClick={this.deletePriceBody} color="primary" autoFocus>
                                                بله انجام شود
                                          </Button>
                                    </DialogActions>
                              </Dialog>
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangePriceBodyCar)
